module.exports = __webpack_public_path__ + "img/menu_ladies_placenta.83bb3af9.png";